import type { IncidentDetailPageViewProps } from './IncidentDetailPage.types';
import { IncidentDetailContainer } from '~/app/dashboard/components/IncidentDetailContainer';

export function IncidentDetailPageView({
  incidentId,
}: IncidentDetailPageViewProps) {
  return <IncidentDetailContainer incidentId={incidentId} />;
}
